import script from "./ViewAManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAManager.vue?vue&type=script&setup=true&lang=js"

import "./ViewAManager.vue?vue&type=style&index=0&id=ee00e08e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee00e08e"]])

export default __exports__